import RouteTemplate from 'ember-route-template'
import BaseRouteTemplate from 'customer-flows/templates/base-route-template'
import Icon from 'customer-flows/components/ui-kit/icon'
import BookingAbandonmentCloseButton from 'customer-flows/components/flow-kit/booking-abandonment/close-button'
import BookingAbandonmentUnloadGuard from 'customer-flows/components/flow-kit/booking-abandonment/unload-guard'
import { action } from '@ember/object'
import { service } from '@ember/service'
import { context } from 'customer-flows/utils/core'
import { t } from 'ember-intl'
import StepContainer from 'customer-flows/components/flow-kit/step-container'
import enterDemoOnShiftClick from 'customer-flows/demo/modifiers/enter-demo-on-shift-click'
import DemoBanner from 'customer-flows/demo/components/banner'

class TilesTemplate extends BaseRouteTemplate<TilesPage> {
  @service legacyNavigator: LegacyNavigator
  @service eventTracker: EventTracker

  @context('account') availabilityBrandingConfig: AccountStore['availabilityBrandingConfig']
  @context('program') initialLayoutName: ProgramStore['initialLayoutName']
  @context('application') partnerKey: ApplicationStore['partnerKey']
  @context('application') loading: ApplicationStore['loading']

  get showBackButton() {
    return this.flowManager.canGoBack
  }

  get showCloseButton() {
    return this.frameManager.isInFrame && !this.frameManager.isEmbed
  }

  @action
  onBackClicked() {
    this.flowManager.back()
  }

  <template>
    <BookingAbandonmentUnloadGuard />

    <div data-testid='tile-flow' class='flex h-full flex-col items-center'>
      <div data-testid='tile-flow__header' class='z-10 w-full'>
        <il-page-header
          {{enterDemoOnShiftClick}}
          logo-url={{this.availabilityBrandingConfig.headerLogoUrl}}
          logo-label={{this.availabilityBrandingConfig.headerText}}
          has-right-side
          header-style={{this.availabilityBrandingConfig.headerStyle}}
        >
          <div slot='right-side'>
            {{#if this.showCloseButton}}
              <BookingAbandonmentCloseButton class='tile-flow__close-button' />
            {{/if}}
          </div>
        </il-page-header>
      </div>

      <DemoBanner />

      {{#if this.loading}}
        <div
          data-testid='flow__loading-indicator'
          class='w-full h-full flex items-center justify-center py-10'
        >
          <il-loader />
        </div>
      {{else}}
        {{#if this.showBackButton}}
          <div class='bg-neutrals-0 shadow-cool-base flex w-full'>
            {{! @glint-ignore: wait until we can't declare custom elements in glint }}
            <il-button variant='ghost' color='gray' small onClick={{this.onBackClicked}} label={{t 'common.back'}}>
              <div class='flex items-center gap-2'>
                <Icon @src='back' />
                <h2 class='text-component-xbold-para-16 text-neutrals-300'>{{t 'common.back'}}</h2>
              </div>
            </il-button>
          </div>
        {{/if}}

        <StepContainer />
      {{/if}}

      <div
        data-testid='tile-flow__footer'
        class='border-neutrals-100 text-reg-para-12 text-neutrals-300 flex w-full items-center gap-2 border-t p-4'
      >
        <Icon @src='peek-logo' />
        <span class='[&>a]:text-neutrals-300 [&>a]:visited:text-neutrals-300 [&>a]:font-bold [&>a]:underline'>{{t
            'tiles.static-footer.text'
            htmlSafe=true
          }}</span>
      </div>
    </div>
  </template>
}

export default RouteTemplate(TilesTemplate)
